<!-- Meter Details Page -->
<div class="meter-details-container">
  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="spinner-container">
    <mat-spinner class="small-spinner"></mat-spinner>
  </div>

  <!-- Error Message -->
  <div *ngIf="!isLoading && errorMessage" class="error-message">
    {{ errorMessage }}
  </div>

  <!-- Meter Details Content -->
  <div *ngIf="!isLoading && !errorMessage" class="meter-content">
    
    <!-- Page Header -->
    <div class="page-header">
      <div class="header-content">
        <h1 class="page-title">
          <!-- <mat-icon class="title-icon">speed</mat-icon> -->
          Meter Details
        </h1>
        <p class="page-subtitle">Manage your registered meters</p>
      </div>
      <div class="header-actions">
        <button mat-flat-button color="primary" (click)="addMeter()" aria-label="Add Meter">
          <mat-icon>add</mat-icon>
          Add Meter
        </button>
      </div>
    </div>

    <!-- Search Filter -->
    <mat-form-field class="filter-field" appearance="outline">
      <mat-label>Search meters</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search by meter number, type, or address">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <!-- Meters Table -->
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" matSort class="meters-table">

        <!-- Meter No Column -->
        <ng-container matColumnDef="MeterNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Meter No</th>
          <td mat-cell *matCellDef="let element">{{element.MeterNo}}</td>
        </ng-container>

        <!-- Meter Type Column -->
        <ng-container matColumnDef="MeterType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Meter Type</th>
          <td mat-cell *matCellDef="let element">{{element.MeterType}}</td>
        </ng-container>

        <!-- Address Column -->
        <ng-container matColumnDef="Address">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
          <td mat-cell *matCellDef="let element">{{element.Address}}</td>
        </ng-container>

        <!-- Organization Column -->
        <ng-container matColumnDef="Organization">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Organization</th>
          <td mat-cell *matCellDef="let element">{{element.Organization || 'N/A'}}</td>
        </ng-container>

        <!-- Consent Column -->
        <ng-container matColumnDef="Consent">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Consent</th>
          <td mat-cell *matCellDef="let element">
            <span class="consent-tag" [ngClass]="element.Consent ? 'granted' : 'missing'">
              {{ element.Consent ? 'Granted' : 'Missing' }}
            </span>
          </td>
        </ng-container>

        <!-- Name Column (TPI only) -->
        <ng-container matColumnDef="Name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let element">{{element.Name}}</td>
        </ng-container>

        <!-- Email Column (TPI only) -->
        <ng-container matColumnDef="Email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
          <td mat-cell *matCellDef="let element">{{element.Email}}</td>
        </ng-container>

        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="displayedMeterColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedMeterColumns;"></tr>

        <!-- No Data Row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data-row" [attr.colspan]="displayedMeterColumns.length">
            <div class="no-data-content">
              <mat-icon class="no-data-icon">electrical_services</mat-icon>
              <h3>No meters found</h3>
              <p>{{ dataSource.filter ? 'No meters match your search criteria.' : 'No meters are linked to this account yet.' }}</p>
              <button mat-flat-button color="primary" (click)="addMeter()">
                <mat-icon>add</mat-icon>
                Add Your First Meter
              </button>
            </div>
          </td>
        </tr>

      </table>

      <!-- Paginator -->
      <mat-paginator 
        [pageSizeOptions]="[5, 10, 20]" 
        showFirstLastButtons 
        aria-label="Select page of meters">
      </mat-paginator>
    </div>

  </div>
</div>
  